<template>
  <div>
    <BaseNotification
      type="success"
      layout="inline"
      class="mb-6 leading-5"
    >
      <div class="font-semibold mb-5 mt-px">
        {{ title }}
      </div>
      {{ message }}
    </BaseNotification>

    <BaseButton
      color="red"
      size="large"
      class="w-full flex items-center justify-center"
      :href="$store.state.user.lastEnquiry.url"
    >
      Contact venue
    </BaseButton>
  </div>
</template>

<script>
import BaseNotification from '@/components/Ui/BaseNotification.vue';
import BaseButton from '@/components/Ui/Buttons/BaseButton.vue';

export default {
  name: 'AlreadyEnquired',
  components: { BaseButton, BaseNotification },

  computed: {
    title() {
      return `You enquired with ${this.$store.state.venue.name} on ${this.$store.state.user.lastEnquiry.date}`;
    },
    message() {
      return `
        Contact ${this.$store.state.manager.shortName} to ask for other dates or discuss your enquiry.
      `;
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
